import React from 'react';
import {connect} from 'react-redux';
import PulseLoader from 'react-spinners/PulseLoader'
import './progress.scss';

const WIDTH = 390;

const ProgressBar = ({loadingProgress, sampleDownloadProgress, width=WIDTH}) => {
    if (sampleDownloadProgress) {
        loadingProgress += (75 * sampleDownloadProgress.downloaded / sampleDownloadProgress.total);

        if (sampleDownloadProgress.downloaded === sampleDownloadProgress.total) {
            loadingProgress -= 75;
        }
    }
    let style = {
        width: width * loadingProgress / 100.0
    };
    return (
        <div className="progress-bar">
          <div className="inner-progress-bar">
          <div className="progress" style={style}/>
            <div className="loading-text">
              {sampleDownloadProgress && sampleDownloadProgress.downloaded < sampleDownloadProgress.total ?
               `Loading stem ${sampleDownloadProgress.downloaded+1} of ${sampleDownloadProgress.total}` : "Loading Player ..."}
            </div>
          </div>
        </div>
    );
};

const mapStateToProps = (state, {sequencerEngine, id})=> {
    return {
        sampleDownloadProgress: state.sequencer.sampleDownloadProgress,
        loadingProgress: state.sequencer.sequenceLoadingProgress[id || sequencerEngine.sequenceId] || 0
    };
};


export default connect(mapStateToProps, null)(ProgressBar);
